import React from 'react'
import styles from './SlidesUploadModal.module.scss'
import { FileListProps } from './types'
import Icon, { IconType } from '@bt-react/components/Icon'

export const fileNameCharLimit = 50

export const FileList = ({ file, onDelete }: FileListProps) => {

  if (!file) return null

  const trimmedFilename = file.name.length > 50
    ? `${file.name.slice(0, fileNameCharLimit / 2)}...${file.name.slice(file.name.length - fileNameCharLimit / 2, file.name.length)}`
    : file.name
  return (
    <div className={styles['file-list']} data-bdd='slides-file-list'>
        Selected file:
      <div className={styles['file-row']} data-bdd='slides-file-row'>
        <div data-bdd='slides-file-name'><Icon name={IconType.iconName.file} />{` ${trimmedFilename}`}</div>
        <div data-bdd='slides-file-size'>{Number(file.size / 1e+6).toFixed(2)}MB</div>
        <div data-bdd='delete-button' className={styles['delete-file-button']} onClick={onDelete}>
          <Icon name={IconType.iconName.trash}/>
        </div>
      </div>
    </div>)

}
